import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Dialog } from 'antd-mobile'
import classnames from 'classnames'
import { handleCatch, postMessage } from '../../utils'
import { requestIntegralData } from '../../actions/integralAction'
import ticketBg_0 from '../../assets/xiniu/integral_ticket_bg_0.png'
import ticketBg_1 from '../../assets/xiniu/integral_ticket_bg_1.png'
import iconSuccess from '../../assets/xiniu/integral_success_icon.png'
import img_list_item_1 from '../../assets/img/integral_list_item_01.png'
import img_list_item_2 from '../../assets/img/integral_list_item_02.png'
import img_list_item_3 from '../../assets/img/integral_list_item_03.png'
import blue_list_item_1 from '../../assets/theme_blue_0/integral/integral_list_item_01.png'
import blue_list_item_2 from '../../assets/theme_blue_0/integral/integral_list_item_02.png'
import blue_list_item_3 from '../../assets/theme_blue_0/integral/integral_list_item_03.png'
import red_0_list_item_1 from '../../assets/v3/integral_grid/red_0/integral_list_item_01.png'
import red_0_list_item_2 from '../../assets/v3/integral_grid/red_0/integral_list_item_02.png'
import red_0_list_item_3 from '../../assets/v3/integral_grid/red_0/integral_list_item_03.png'
import orange_0_list_item_1 from '../../assets/v3/integral_grid/orange_0/integral_list_item_01.png'
import orange_0_list_item_2 from '../../assets/v3/integral_grid/orange_0/integral_list_item_02.png'
import orange_0_list_item_3 from '../../assets/v3/integral_grid/orange_0/integral_list_item_03.png'
import { withTranslation } from 'react-i18next'


// import imgListItem4 from '../../assets/img/integral_list_item_04.png'

const sets = {
  imgListItem1: '',
  imgListItem2: '',
  imgListItem3: '',
}
switch (process.env['REACT_APP_CHANNEL']) {
  case 'ytyg':
    Object.assign(sets, {
      imgListItem1: orange_0_list_item_1,
      imgListItem2: orange_0_list_item_2,
      imgListItem3: orange_0_list_item_3,
    })
    break
  case 'dyyg':
    Object.assign(sets, {
      imgListItem1: red_0_list_item_1,
      imgListItem2: red_0_list_item_2,
      imgListItem3: red_0_list_item_3,
    })
    break
  case 'qxtj':
  case 'qxyg':
  case 'qxdg':
  case 'tjyg':
    Object.assign(sets, {
      imgListItem1: blue_list_item_1,
      imgListItem2: blue_list_item_2,
      imgListItem3: blue_list_item_3,
    })
    break
  // case ('xiniu'):
  // case ('xibei'):
  //   break
  default:
    Object.assign(sets, {
      imgListItem1: img_list_item_1,
      imgListItem2: img_list_item_2,
      imgListItem3: img_list_item_3,
    })
}

class HaiouModal extends React.PureComponent {
  static propTypes = {
    visible: PropTypes.bool,
    title: PropTypes.string,
    value: PropTypes.string,
    onConfirmCancel: PropTypes.func,
    onConfirmSubmit: PropTypes.func,
  }

  render () {
    const { visible, title, value, onConfirmCancel, onConfirmSubmit } = this.props
    return <Dialog
      visible={visible}
      title={title}
      closeOnMaskClick={false}
      actions={[[{
        key: 'cancel',
        text: '取消',
        onClick: onConfirmCancel,
        danger: false,
      }, {
        key: 'submit',
        text: '兑换',
        bold: true,
        danger: true,
        onClick: onConfirmSubmit
      }]]}
      content={<div style={{ textAlign: 'center', fontSize: 'larger' }}>
        <div>{value}积分</div>
        <div>兑换 1 张</div>
      </div>}
    />
  }
}

class XiniuModal extends React.PureComponent {
  static propTypes = {
    visible: PropTypes.bool,
    title: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onConfirmCancel: PropTypes.func,
    onConfirmSubmit: PropTypes.func,
  }

  render () {
    const { visible, title, value, onConfirmCancel, onConfirmSubmit } = this.props
    return <Dialog
      className={'integral-modal'}
      visible={visible}
      closeOnMaskClick={false}
      actions={[[{
        key: 'cancel',
        text: '取消',
        onClick: onConfirmCancel,
        danger: false,
      }, {
        key: 'submit',
        text: '兑换',
        bold: true,
        danger: true,
        onClick: onConfirmSubmit
      }]]}
      content={<div className={'integral-modal__body'}>
        <img className={'integral-modal__ticket'} src={ticketBg_0} alt=''/>
        <div className={'integral-modal__content'}>
          <div className={'integral-modal__title truncate'} title={title}>{title}</div>
          <div className={'integral-modal__sub'}>{value}</div>
        </div>
        <img className={'integral-modal__ticket'} src={ticketBg_1} alt=''/>
      </div>}
    />
  }
}

function RenderModal (props) {
  if (process.env['REACT_APP_CHANNEL'] === 'haiou') {
    return <HaiouModal {...props} />
  } else {
    return <XiniuModal {...props} />
  }
}

class IntegralList1Item extends React.PureComponent {
  static propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onButtonClick: PropTypes.func
  }
  static defaultProps = {
    value: '-',
    title: '',
    text: '',
    extend: '',
    buttonText: '兑换'
  }

  render () {
    const {
      value, text, extend, buttonText, onButtonClick, contract,
      type
    } = this.props
    let { title } = this.props
    let titleEx = ''
    // let valueClass = `integral-list__value integral-list__value--${type}`
    let valueClass = classnames(`integral-list__value integral-list__value--${type}`, {
      [`integral-list__value--${contract}`]: contract
    })
    try {
      title = title.replaceAll('（', '(')
      title = title.replaceAll('）', ')')
      if (title.match('(套装)')) {
        title = title.replace('(套装)', '')
        titleEx = ('(套装)')
      }
    } catch (e) {
      console.error(e.message)
    }
    return <div className='integral-list__item'>
      <div className={valueClass}>
        &#165;<span>{value}</span>
      </div>
      <div className='integral-list__main'>
        <div className='integral-list__title'>{title}<span>{titleEx}</span></div>
        <div className='integral-list__text'>{text}</div>
        <div className='integral-list__extend'>{extend}</div>
      </div>
      <div className='integral-list__button' onClick={onButtonClick}>{buttonText}</div>
    </div>
  }

}

@withTranslation()
@connect(state => {
  return {
    store: {
      listData: state.integralList.listData
    }
  }
})
class IntegralList1 extends React.PureComponent {
  state = {
    modalVisible: false,
    pendingData: {},
    confirmVisible: false
  }

  render () {
    const { listData } = this.props.store
    const { confirmVisible, pendingData } = this.state
    return <div>
      <div className='integral-list'>
        {
          listData.map(item => {
            return <IntegralList1Item
              key={item['id']}
              value={item['value'] || '-'}
              title={item['title']}
              text={`${item['integral']}积分`}
              extend={item['sales'] ? `${item['sales']}人兑换` : ''}
              contract={item['contract']}
              type={item['type']}
              onButtonClick={this.onItemClick.bind(this, item)}
            />
          })
        }
      </div>
      <RenderModal
        visible={confirmVisible}
        title={pendingData['title']}
        value={pendingData['integral']}
        onConfirmSubmit={this.onConfirmSubmit}
        onConfirmCancel={this.onConfirmCancel}
      />
      {/*<Modal*/}
      {/*  visible={confirmVisible}*/}
      {/*  transparent*/}
      {/*  title={pendingData['title']}*/}
      {/*  maskClosable={false}*/}
      {/*  footer={[{*/}
      {/*    text: '取消', onPress: this.onConfirmCancel*/}
      {/*  }, {*/}
      {/*    text: '兑换', onPress: this.onConfirmSubmit*/}
      {/*  }]}*/}
      {/*  wrapProps={{ onTouchStart: handleWrapTouchStart }}*/}
      {/*>*/}
      {/*  <div style={{ textAlign: 'center', fontSize: 'larger' }}>*/}
      {/*    <div>{pendingData['integral']}积分</div>*/}
      {/*    <div>兑换 1 张</div>*/}
      {/*  </div>*/}
      {/*</Modal>*/}
    </div>
  }

  onItemClick = (item) => {
    this.setState({
      pendingData: { ...item },
      confirmVisible: true
    })
  }
  onConfirmSubmit = () => {
    const { pendingData } = this.state
    if (!pendingData['id']) {
      console.warn(`pendingData['id'] is ${pendingData['id']}`)
      window.toast.fail('数据错误，兑换失败', 2)
      return
    }
    this.postIntegral(pendingData['id'])
  }
  onConfirmCancel = () => {
    this.setState({
      confirmVisible: false
    })
  }
  postIntegral = (id, count = 1) => {
    const { t } = this.props
    let config = {
      method: 'post',
      url: window.API.Integral.postIntegralTicket(id, count)
    }
    window.toast.show('')
    window.axios.request(config)
      .then(() => {
        window.toast.hide()
        this.setState({ confirmVisible: false }, () => {
          (process.env['REACT_APP_CHANNEL'] === 'haiou')
            ? Dialog.alert({
              title: t('integral.modal_success'),
              confirmText: t('common.ok')
            })
            : Dialog.confirm({
              content: <div className={'leading-normal text-2xl font-bold text-center'}>
                <img className={'w-6 flex-shrink-0 inline-block'} src={iconSuccess} alt=''/>&nbsp;
                <div className={'inline-block'}>{t('integral.modal_success')}</div>
              </div>,
              cancelText: t('common.back'),
              confirmText: t('common.order'),
              onConfirm: () => {
                postMessage({
                  type: window.POST_TYPE.BUY,
                  data: {
                    extMap: {
                      productId: this.state.pendingData['productId'],
                      contract: this.state.pendingData['contract'],
                    }
                  }
                })
              },
            })
              .then()
          this.props.dispatch(requestIntegralData())
        })
        // })
      })
      .catch((e) => {
        if (e.message.match('兑换数量已满')) {
          this.setState({ confirmVisible: false }, () => {
            window.toast.hide()
            Dialog.confirm({
              title: <div><span className={'text-red-600'}>此券今日暂被兑罄</span><br/>明日请尽早兑换</div>,
              content: <div className={'text-zinc-500 text-center'}>先看看其他券吧</div>,
              confirmText: '兑其他券'
            }).then()
          })
        } else if (e.message.match('库存确认中')) {
          this.setState({ confirmVisible: false }, () => {
            window.toast.hide()
            Dialog.alert({
              title: '库存确认中',
              content: '若库存充足，系统会自动发放相应优惠卷；若库存不足，系统会自动返还积分。如有疑问，请联系在线客服。',
              confirmText: '确认'
            }).then()
          })
        } else if (e.message.match('心碎一地')) {
          let { star: start, end } = JSON.parse(e.message)
          this.setState({ confirmVisible: false }, () => {
            window.toast.hide()
            Dialog.alert({
              title: '心碎一地，来得不是时候',
              content: `活动时间${start}至${end}，等你哦`,
              confirmText: '知道了'
            }).then()
          })
        } else {
          handleCatch(e)
        }
      }).finally(() => this.setState({ confirmVisible: false }))
  }
}

class IntegralList2Item extends React.PureComponent {
  render () {
    const { title, text, productImgUrl, onClick } = this.props
    return <div className={'integral-list2__item'}>
      <img className={'integral-list2__item__bg'} src={sets.imgListItem1} alt=''/>
      {productImgUrl && <img className={'integral-list2__item__img'} src={productImgUrl} alt=''/>}
      <img className={'integral-list2__item__bg'} src={sets.imgListItem2} alt=''/>
      <div className={'integral-list2__item__content'}>
        <div className={'integral-list2__item__title'}>{title}</div>
        <div className={'integral-list2__item__text'}>{text} 积分</div>
      </div>
      <img className={'integral-list2__item__bg'} onClick={onClick} src={sets.imgListItem3} alt=''/>
      {/*<img className={'integral-list2__item__bg'} src={imgListItem4} alt=''/>*/}
    </div>
  }
}

@withTranslation()
@connect(state => {
  return {
    store: {
      listData: state.integralList.listData
    }
  }
})
class IntegralList2 extends React.PureComponent {
  state = {
    modalVisible: false,
    pendingData: {},
    confirmVisible: false
  }

  render () {
    const { listData } = this.props.store
    const { confirmVisible, pendingData } = this.state

    return <>
      <div className={'integral-list2'}>
        {
          listData.map(item => (
            <IntegralList2Item
              key={item['id']}
              title={item['title']}
              text={item['integral']}
              productImgUrl={item['productImgUrl']}
              onClick={this.onItemClick.bind(this, item)}
            />
          ))
        }
      </div>
      <RenderModal
        visible={confirmVisible}
        title={pendingData['title']}
        value={pendingData['integral']}
        onConfirmSubmit={this.onConfirmSubmit}
        onConfirmCancel={this.onConfirmCancel}
      />
    </>
  }

  onItemClick = (item) => {
    this.setState({
      pendingData: { ...item },
      confirmVisible: true
    })
  }

  onConfirmSubmit = () => {
    const { pendingData } = this.state
    if (!pendingData['id']) {
      console.warn(`pendingData['id'] is ${pendingData['id']}`)
      window.toast.fail('数据错误，兑换失败', 2)
      return
    }
    this.postIntegral(pendingData['id'])
  }
  onConfirmCancel = () => {
    this.setState({
      confirmVisible: false
    })
  }
  postIntegral = (id, count = 1) => {
    const { t } = this.props
    let config = {
      method: 'post',
      url: window.API.Integral.postIntegralTicket(id, count)
    }
    window.toast.show('')
    window.axios.request(config)
      .then(() => {
        window.toast.hide()
        this.setState({ confirmVisible: false }, () => {
          (process.env['REACT_APP_CHANNEL'] === 'haiou')
            ? Dialog.alert({
              title: t('integral.modal_success'),
              confirmText: t('common.ok')
            })
            : Dialog.confirm({
              content: <div className={'leading-normal text-2xl font-bold text-center'}>
                <img className={'w-6 flex-shrink-0 inline-block'} src={iconSuccess} alt=''/>&nbsp;
                <div className={'inline-block'}>{t('integral.modal_success')}</div>
              </div>,
              cancelText: t('common.back'),
              confirmText: t('common.order'),
              onConfirm: () => {
                postMessage({
                  type: window.POST_TYPE.BUY,
                  data: {
                    extMap: {
                      productId: this.state.pendingData['productId'],
                      contract: this.state.pendingData['contract'],
                    }
                  }
                })
              },
            })
              .then()
          this.props.dispatch(requestIntegralData())
        })
        // })
      })
      .catch((e) => {
        if (e.message.match('兑换数量已满')) {
          this.setState({ confirmVisible: false }, () => {
            window.toast.hide()
            Dialog.confirm({
              title: <div><span className={'text-red-600'}>此券今日暂被兑罄</span><br/>明日请尽早兑换</div>,
              content: <div className={'text-zinc-500 text-center'}>先看看其他券吧</div>,
              confirmText: '兑其他券'
            }).then()
          })
        } else if (e.message.match('库存确认中')) {
          this.setState({ confirmVisible: false }, () => {
            window.toast.hide()
            Dialog.alert({
              title: '库存确认中',
              content: '若库存充足，系统会自动发放相应优惠卷；若库存不足，系统会自动返还积分。如有疑问，请联系在线客服。',
              confirmText: '确认'
            }).then()
          })
        } else if (e.message.match('心碎一地')) {
          let { star: start, end } = JSON.parse(e.message)
          this.setState({ confirmVisible: false }, () => {
            window.toast.hide()
            Dialog.alert({
              title: '心碎一地，来得不是时候',
              content: `活动时间${start}至${end}，等你哦`,
              confirmText: '知道了'
            }).then()
          })
        } else {
          handleCatch(e)
        }
      }).finally(() => this.setState({ confirmVisible: false }))
  }
}

const IntegralList = process.env['REACT_APP_CHANNEL'] === 'haiou'
  ? IntegralList1 : IntegralList2
export default IntegralList
